import React from "react";
import { EVT_KEYDOWN, KEY_Y } from "../../../lib";
import { pageShareUrl, shareOnFacebook } from "../../../helpers";
import { shareBlack, shareWhite } from "../../../images";
import { ReaderDoc } from "../PageContents/index";

type Props = {
    doc: ReaderDoc;
    page_id: number;
    isDark: boolean;
};

export default class Share extends React.Component<Props> {
    componentDidMount() {
        window.addEventListener(EVT_KEYDOWN, this.onShortcut);
    }

    componentWillUnmount() {
        window.removeEventListener(EVT_KEYDOWN, this.onShortcut);
    }

    share = () => {
        const { doc, page_id } = this.props;
        const page = doc.pages.filter((p) => p.id === page_id)[0];
        shareOnFacebook(pageShareUrl(doc, page));

        const { gtag } = window;
        gtag("event", "share", {
            event_category: "page",
            event_label: `whatsapp-${doc.id}-${page_id}`,
        });
    };

    onShortcut = (evt: KeyboardEvent) => {
        if (evt.key.toUpperCase() === KEY_Y) {
            this.share();
        }
    };

    onClick = () => this.share();

    render() {
        return (
            <img
                alt="شئیر کرو"
                src={this.props.isDark ? shareWhite : shareBlack}
                onClick={this.onClick}
            />
        );
    }
}
